import React from 'react'
import { withRouter } from 'react-router'
import { Link } from 'react-router-dom'
import SearchUI from '../../../widgets/input/SearchUI'
import LRTableBodyUI from '../../../widgets/layout/LRTableBodyUI'
import LRTableRowUI from '../../../widgets/layout/LRTableRowUI'
import LRTableActionsUI from '../../../widgets/layout/LRTableActionsUI'
import IconButtonUI from '../../../widgets/action/IconButtonUI'
import './VendorList.css'

const ProjectListUI = ({ context, messageList, projectList,
    // filters
    searchFilter, onSearchFilterChange,
    // modes
    selectedCount,
    // event handlers
    onRefreshClick, onCreateClick, onUpdateClick, onDeleteClick, onRowClick, onDownloadPrjFileClick}) =>
    <div className='c_vndrs'>
        <LRTableActionsUI location='top'
            left={
                <ActionLeftUI
                    context={context}
                    messageList={messageList}
                    selectedCount={selectedCount}
                    onRefreshClick={onRefreshClick}
                    onCreateClick={onCreateClick}
                    onUpdateClick={onUpdateClick}
                    onDeleteClick={onDeleteClick}
                />
            }
            right={
                <ActionTopRightUI
                    context={context}
                    messageList={messageList}
                    searchFilter={searchFilter}
                    onSearchFilterChange={onSearchFilterChange}
                />
            }
        />

        <LRTableBodyUI>
            {
                projectList.map((project, i) =>
                    <ProjectRowUI key={i} context={context} project={project}
                        messageList={messageList} onRowClick={onRowClick} onDownloadPrjFileClick={onDownloadPrjFileClick}
                    />
                )
            }
        </LRTableBodyUI>
    </div>

const ActionLeftUI = ({ context, messageList, selectedCount, onRefreshClick, onCreateClick, onUpdateClick, onDeleteClick }) =>
    <React.Fragment>
        {
            selectedCount === 0 &&
            <div className='g_flex_h'>
                <IconButtonUI messageList={messageList} icon='icon-refresh' onClick={onRefreshClick} label='Refresh' />
                {/*
          context.permissions.includes('acc_manage') &&
          <IconButtonUI messageList={messageList} icon='icon-plus' onClick={onCreateClick} labelKey='c_create_vendor' />
        */}
            </div>
        }
        {
            selectedCount > 0 &&
            <div className='action g_flex_h'>
                {
                    selectedCount === 1 &&
                    <IconButtonUI messageList={messageList} icon='icon-pencil' onClick={onUpdateClick} label='Update Project' />
                }
                <IconButtonUI messageList={messageList} icon='icon-trash-o' onClick={onDeleteClick} label='Delete Project' />
            </div>
        }
    </React.Fragment>

const ActionTopRightUI = ({ context, messageList, searchFilter, onSearchFilterChange }) =>
    <div className='g_flex_h'>
        <SearchUI value={searchFilter} onChange={onSearchFilterChange} />
    </div>

const ProjectRowUI = ({ context, messageList, project, onRowClick , onDownloadPrjFileClick}) =>
    <LRTableRowUI
        context={context} className='g_flex_top'
        left={<RowLeftUI context={context} project={project} onRowClick={onRowClick} />}
        right={<RowRightUI project={project} messageList={messageList} onDownloadPrjFileClick={onDownloadPrjFileClick} />}
        rowId={project.projectId}
    />

const RowLeftUI = ({ context, project, onRowClick }) =>
    <div className='g_flex_h g_flex_top'>
        <div>
            <span>{project.projectName}</span>
            <div className='g_muted g_flex_v'>
                <span>{project.customer.customerName}</span>
                <span>Expected Margin Percent: {project.expectedMarginPercentF}</span>
                <span>Ld Paid: {project.ldPaidF2}</span>
                <span>Project Cost: {project.projectCostF2}</span>
            </div>
        </div>
    </div>

const RowRightUI = ({ project, messageList, onDownloadPrjFileClick}) =>
    <div className='right g_flex_v'>
        {
          project.fileList['attachments'] && 
          <Link onClick={onDownloadPrjFileClick} to='#' data-row-id={project.projectId}>
            Download attachment
          </Link>
        }
    </div>

export default withRouter(ProjectListUI)
